import React from 'react';

const PasswordStrengthChecker = ({ checks }) => {
    return (
        <div className="alert px-4 py-3 mb-0" role="alert" style={{textAlign: 'left'}}>
            <ul className="list-unstyled mb-0">
                <li className={`requirements leng ${checks.minLength ? 'text-success' : 'text-danger'}`}>
                    {checks.minLength ? <i className="fas fa-check text-success me-2"></i> : <i className="fas fa-times text-danger me-3"></i>}
                    Your password must be minimum 8 characters in length.
                </li>
                <li className={`requirements leng ${checks.maxLength ? 'text-success' : 'text-danger'}`}>
                    {checks.maxLength ? <i className="fas fa-check text-success me-2"></i> : <i className="fas fa-times text-danger me-3"></i>}
                    Your password must be maximum 20 characters in length.
                </li>
                <li className={`requirements big-letter ${checks.upperCase ? 'text-success' : 'text-danger'}`}>
                    {checks.upperCase ? <i className="fas fa-check text-success me-2"></i> : <i className="fas fa-times text-danger me-3"></i>}
                    Your password must have at least one upperCase letter.
                </li>
                <li className={`requirements num ${checks.number ? 'text-success' : 'text-danger'}`}>
                    {checks.number ? <i className="fas fa-check text-success me-2"></i> : <i className="fas fa-times text-danger me-3"></i>}
                    Your password must have at least one number.
                </li>
                <li className={`requirements special-char ${checks.specialChar ? 'text-success' : 'text-danger'}`}>
                    {checks.specialChar ? <i className="fas fa-check text-success me-2"></i> : <i className="fas fa-times text-danger me-3"></i>}
                    Your password must have at least one special character.
                </li>
            </ul>
        </div>
    );
}

export default PasswordStrengthChecker;
